module.exports = __webpack_public_path__ + "static/media/sologo.d4645fdd.png";